import { render, staticRenderFns } from "./layout-bigvip.vue?vue&type=template&id=7e94eb54&scoped=true"
import script from "./layout-bigvip.vue?vue&type=script&lang=js"
export * from "./layout-bigvip.vue?vue&type=script&lang=js"
import style0 from "./layout-bigvip.vue?vue&type=style&index=0&id=7e94eb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94eb54",
  null
  
)

export default component.exports